module.exports = __webpack_public_path__ + "static/img_2317-936edd9b59e57c0ca3466cdaa4bdff54.webp";